<template>  
<div class="row" style="padding: 30px;">
    <div class="col-12" v-if="success">
        <div class="row" style="margin-top: 75px">
            <div class="col-12 center">
                <h2 class="teal-text">Success!</h2>
                <p>The reservation has been registered.</p>
                <button @click="closeModal" style="margin-top: 20px" class="waves-effect waves-light teal btn-small btn-block">Close</button>
            </div>
        </div>
    </div>
    <div class="col-12" v-if="!success">
        <div class="row">
            <div class="col-12">
                <h5>Make a Booking | Office {{ selectedOffice.naam }}</h5>
            </div>
        </div>
        <div class="row margin-top-30">
            <div class="col-12">
                <h5 class="teal-text">{{ day }}</h5>
                <p class="grey-text">{{ time }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label for="">Name Employee</label>
                <input type="text" v-model="name_employee" :disabled="true">
            </div>
        </div>
        <div class="row margin-top-20">
            <div class="col-12">
                <a class="waves-effect waves-light btn" @click="confirmBooking()">Confirm</a>
            </div>
        </div>
                <div class="row" v-if="feedback">
            <div class="col-12">
                <p class="red-text">{{ feedback }}</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import addBooking from '@/components/modals/addBooking'
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment'
import firebase from 'firebase'
export default {
    name: 'addBooking',
    data() {
        return {
            name_employee: null,
            time: null,
            day: null,
            feedback: null,
            success: false,
            user: null,
        }
    },
    props: ['office_id', 'timestamp'],
    computed: {
      ...mapGetters(['selectedOffice']),
    },
    methods: {
        ...mapActions(['createBooking']),
        confirmBooking(){
            if(this.name_employee){
                let info = {
                    officeid: this.office_id,
                    employee: this.name_employee,
                    timestamp: this.timestamp,
                    location: this.selectedOffice.naam
                }
                this.createBooking(info)
                this.success = true;
            } else {
                this.feedback = "You must provide a name."
            }
        },
        closeModal(){
            this.$emit('close')
        }
    },
    created(){
        this.time = moment(this.timestamp).format("Do MMM")
        this.day = moment(this.timestamp).format('dddd')
        this.user = firebase.auth().currentUser
        this.name_employee = this.user.displayName
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modals/addBooking.vue